import { render } from "./AnnotationContent.vue?vue&type=template&id=087ca8b8&scoped=true"
import script from "./AnnotationContent.vue?vue&type=script&lang=js"
export * from "./AnnotationContent.vue?vue&type=script&lang=js"

import "../../assets/scss/document_annotations.scss?vue&type=style&index=0&id=087ca8b8&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087ca8b8"]])

export default __exports__